module.exports = __webpack_public_path__ + "img/bioseguridad.5f421dd1.png";